import React from "react";
import Marquee from "react-fast-marquee";
import { Banknote, FileCheck, CreditCard } from "lucide-react";

const ICONS = [Banknote, FileCheck, CreditCard];
const MARQUEE_SPEED = 45;
const MARQUEE_REPEATS = 3;

const slugify = (s) => s.toLowerCase().replace(/[\s/]+/g, "-");

export default function Payments({ t }) {
  const methods = t.payments.methods.map((name, i) => ({ name, icon: ICONS[i] }));
  const items = Array.from({ length: MARQUEE_REPEATS }, (_, rep) =>
    methods.map((m) => ({ ...m, key: `${slugify(m.name)}-${rep}` }))
  ).flat();

  return (
    <section data-testid="payments-section" className="bg-white border-y border-brand py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <span className="section-tag" data-testid="payments-tag">{t.payments.tag}</span>
            <h2
              data-testid="payments-title"
              className="font-display font-black text-brand-primary text-2xl sm:text-3xl md:text-4xl tracking-tighter mt-4"
            >
              {t.payments.title}
            </h2>
          </div>
          <p className="text-sm md:text-base text-brand-muted max-w-md">{t.payments.subtitle}</p>
        </div>
      </div>

      <div className="marquee-wrap">
        <Marquee speed={MARQUEE_SPEED} gradient={false} pauseOnHover>
          {items.map((m, i) => (
            <div
              key={m.key}
              data-testid={`payment-${slugify(m.name)}-${i}`}
              className="flex items-center gap-4 mx-6 md:mx-10 py-4 px-6 md:px-8 border border-brand bg-brand-light"
            >
              <m.icon className="w-6 h-6 md:w-7 md:h-7 text-brand-accent" strokeWidth={2} />
              <span className="font-display font-bold text-lg md:text-xl text-brand-primary tracking-tight">{m.name}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
